<script>
import { mapGetters } from 'vuex'

import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import { XIcon } from 'vue-feather-icons'
import CpExample from '@/assets/images/cp-example.png'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  components: { XIcon },
  extends: BaseModal,
  data: function () {
    return { CpExample }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    })
  },
  mounted() {
    eventBus.$emit('refresh-token-via-websockets')
  },
  methods: {
    getFreeBoxes(size) {
      if (!this.cp) {
        return 0
      }

      let allBoxes = []
      for (const unit of this.cp.units) {
        allBoxes.push(unit.boxes)
      }
      let count = allBoxes.flat().filter((box) => {
        return (
          box.size == size &&
          box.status == 'free' &&
          box.isActive &&
          box.members.length == 0 &&
          !box.isTablet
        )
      }).length

      return count
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="close(false)")
  .modal-body
    h1.page__header {{ $t('modals.availableBoxesModal.header') }}
    h3.page__description.mb-5 {{ $t('modals.availableBoxesModal.subheader') }}

    p.font-weight-bold {{ $t('modals.availableBoxesModal.availableLockers') }}

    .row
      .col-6.col-lg-4
        .row
          .col-12.col-lg-3
            .box-info
              span.font-weight-bold.mr-2 S
              span {{ getFreeBoxes('s') }}
          .col-12.col-lg-3
            .box-info
              span.font-weight-bold.mr-2 M
              span {{ getFreeBoxes('m') }}
          .col-12.col-lg-3
            .box-info
              span.font-weight-bold.mr-2 L
              span {{ getFreeBoxes('l') }}
          .col-12.col-lg-3
            .box-info
              span.font-weight-bold.mr-2 XL
              span {{ getFreeBoxes('xl') }}
        .row
          .col-12.col-lg-3
            .box-info
              span.font-weight-bold.mr-2 XXL
              span {{ getFreeBoxes('xxl') }}
      .col-6.col-lg-4.overflow-container
        img.w-100.mb-4(:src="CpExample")
        .text-center.text-muted {{ $t('modals.availableBoxesModal.exampleCollectomate') }}
</template>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
.box-info {
  background: $gray-lightest;
  padding: 1rem;
  border-radius: 1rem;
  margin-bottom: 2rem;
  text-align: center;
}

.overflow-container {
  overflow: hidden;
  img {
    @media (max-width: 991.98px) {
      width: 160% !important;
      margin-left: -30%;
    }
  }
}
</style>
